import Phaser from 'phaser';

import { api, restoreSession } from './net/api.js';
import { initPlatform, platform, registerPush } from './platform/native.js';
import { BootScene } from './scenes/BootScene.js';
import { GameScene, type GameStart } from './scenes/GameScene.js';
import { ui } from './ui/dom.js';
import { authScreen, characterScreen } from './ui/screens.js';
import type { WorldConfig } from './world/coords.js';

async function boot(): Promise<void> {
  await initPlatform();
  if (!(await restoreSession())) await authScreen();
  const summary = await characterScreen();
  const [config, char] = await Promise.all([
    api<WorldConfig>('/world/config/', { auth: false }),
    api<GameStart['char']>(`/characters/${summary.id}/`),
  ]);
  ui().replaceChildren();
  registerPush().then((token) => token && api('/auth/push-token/', { body: { platform, token } })).catch(() => {});

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game',
    backgroundColor: '#050606',
    pixelArt: true,
    antialias: false,
    scale: { mode: Phaser.Scale.RESIZE, width: window.innerWidth, height: window.innerHeight },
    fps: { target: 60, smoothStep: true },
    input: { activePointers: 3 },
    scene: [BootScene, GameScene],
  });
  game.registry.set('start', { char, config } satisfies GameStart);
}

boot().catch((e) => {
  console.error(e);
  ui().innerHTML = '<div class="screen"><div class="card"><h2>Błąd uruchomienia</h2><p>Sprawdź połączenie i spróbuj ponownie.</p></div></div>';
});
